import React, { useState, useEffect } from "react";
import LeftMenu01 from "../../components/layout/leftMenu01.jsx";
import Header from "../../components/layout/header-candidate.jsx";
import { backendApi } from "../../api/apiService";
import { useSelector } from "react-redux";
import moment from "moment";
export default function CandidateSchedule() {
  const [menuClick, setMenuClick] = useState(false);
  const { candidateData } = useSelector((state) => state.login);
  const [schedules, setSchedules] = useState([]);

  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  useEffect(() => {
    getcandidateSchedules();
    setTimeout(() => {
      document.getElementById("ScheduleMenu").classList.add("active");
    }, 500);
  }, []);
  const getcandidateSchedules = () => {
    const req = {
      functionName: "getCandidateSchedules",
      email_id: candidateData[0].email_id,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          setSchedules(response.scheduleList);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <LeftMenu01 menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header
          Header="Candidate Schedule"
          toggleMenu={toggleMenu}
          menuClick={menuClick}
        />
        <div className="main-container">
          <div className="row mb-3">
            <div className="col-lg-12 col-md-12">
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="row">
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th width="50px">Sl.No</th>
                            <th >Opening Position</th>
                            <th >Department Name</th>
                            <th >Interview Date</th>
                            <th >Time Of Interview</th>
                            <th >Interview Link</th>
                            <th >Type Of Interview </th>
                            <th>Job Location</th>
                            <th>Name of Interviewer</th>
                            <th >Suggetions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {schedules.map((data, index) => {
                            const startDate = moment(
                              data.start_date,
                              "DD MMM YYYY hh:mm A"
                            );
                            const date = startDate.format("DD-MM-YYYY");
                            const time = startDate.format("hh:mm A");
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{data.summary}</td>
                                <td>{data.department_name}</td>
                                <td width="150px">{date}</td>
                                <td>{time}</td>
                                <td>
                                  <div
                                    className="text-primary cursor-pointer"
                                    onClick={() =>
                                      window.open(
                                        data.interviewLink,
                                        "_blank",
                                        "noopener,noreferrer"
                                      )
                                    }
                                  >
                                    {data.interviewLink}
                                  </div>
                                </td>
                                <td>
                                  {" "}
                                  {data.interview_type === "Online" ? (
                                    <div className="text-success">
                                      {data.interview_type}
                                    </div>
                                  ) : (
                                    <div className="text-danger">
                                      {data.interview_type}
                                    </div>
                                  )}
                                </td>
                                <td>{data.location}</td>
                                <td>{data.interviewer}</td>
                                <td>{data.remarks ? data.remarks : "NA"}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
